import { createRouter, createWebHistory } from 'vue-router'
import TasksView from '../views/TasksView.vue'
import ReportView from '../views/ReportView.vue'

const routes = [
  { path: '/', name: 'Tasks', component: TasksView },
  { path: '/report', name: 'Report', component: ReportView }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router